module.exports = __webpack_public_path__ + "media/Images/investment-lineup-image-9768173aeea00086b5d2cce0609bdd3d.jpg";